import {
  AfterViewChecked,
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  OnInit,
  TemplateRef,
  ViewChild,
  ViewEncapsulation
} from '@angular/core';
import {BsModalRef, BsModalService} from "ngx-bootstrap/modal";
import {CesiumAdapterService} from "../../services/cesiumAdapter21/cesium-adapter.service";
import {OverlayService} from "../../services/overlay/overlay.service";
import {Overlay} from "../../services/overlay/Overlay";
import {GeoLibService} from "../../services/geoLib/geo-lib.service";
import {MapPosition} from "../../models/MapPosition";
import {OverlayCollectionFactory} from "../../services/overlay/OverlayCollectionFactory";
import {HintManagerService} from "../../services/hintManager/hint-manager.service";
import {isCanvasStoreAllowed} from "../../../configs/view_only";

declare const Yiit: any;

@Component({
  selector: 'app-canvas-store',
  templateUrl: './canvas-store.component.html',
  styleUrls: ['./canvas-store.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class CanvasStoreComponent  {

  public modalRef: BsModalRef;
  public selectedItem = null;
  public selectedAction = null;
  public myCanvases = false;
  public isLoading = false;

  public newOverlayName = '';
  public coordinates:number[] = null;
  public location = null;
  public availableImages: Object = null;
  public availableImagesByDate = null;
  public selectedOverlayImage = null;
  public area = null;
  public locationError = null;
  public previewError = null;
  public drawnOverlay: Overlay = null;
  private groupByDate: boolean = false;

  public errorMessage: string = '';

  public Yiit = Yiit;

  @ViewChild('template', {static: false}) templateRef: TemplateRef<any>;

  constructor(
    protected modalService: BsModalService,
    public view: CesiumAdapterService,
    public overlayService: OverlayService,
    private ref: ChangeDetectorRef,
    private geoLibService: GeoLibService,
    private overlayCollectionFactory: OverlayCollectionFactory,
    private hintManagerService: HintManagerService
  ) { }

  get selectedImagery() {
    return this.view.imageryProviders[this.selectedItem[1]];
  }
  get selectedOverlay() {
    return this.overlayService.availableOverlayServices[this.selectedItem[1]];
  }

  show(reset = true) {
    if (isCanvasStoreAllowed){
      if (reset) {
        this.selectedAction = null;
        this.selectedItem = null;
      }
      this.modalRef = this.modalService.show(this.templateRef);
      this.modalService.onHide.subscribe(()=>{
        this.errorMessage = '';
      })
    }
  }

  isImagerySelected(key) {
    return (this.view.enabledImageryProviders.indexOf(key) >= 0);
  }

  removeImagery(key) {
    if (this.view.enabledImageryProviders.length == 1) {
      alert(Yiit.t("Sorry, at least one imagery must be selected"));
      return;
    }
    this.view.disableImageryProvider(key);
  }

  addImagery(key) {
    this.view.enableImageryProvider(key);
    this.modalRef.hide();
  }

  isOverlaySelected(key) {
    return this.overlayService.hasOverlayOfType(key);
  }

  getOverlaysOfType(key) {
    return this.overlayService.getOverlaysOfType(key);
  }

  countOverlaysOfType(key) {
    return this.getOverlaysOfType(key).length;
  }

  getLabelClassForStatus(status) {
    switch (status) {
      case Overlay.STATUS_ACTIVE:
        return { 'label-success': true };
      case Overlay.STATUS_PENDING:
        return { 'label-warning': true };
      default:
        return { 'label-default': true };
    }
  }

  addNewInstanceOfSelectedOverlay() {
    this.selectedAction = 'add';
    if (this.coordinates) {
      this.previewOverlay();
    }
  }

  addOverlay(key) {
    this.isLoading = true;
    this.overlayService.addOverlay(key, this.newOverlayName, this.coordinates, this.selectedOverlayImage).then(() => {
      this.selectedAction = null;
      this.isLoading = false;
      this.newOverlayName = '';
      // this.coordinates = null;
      // this.location = null;
      this.locationError = null;
      this.availableImages = null;
      this.selectedOverlayImage = null;
    });
  }

  exitAddingOverlay() {
    this.selectedAction = null;
    this.locationError = null;
    this.availableImages = null;
    this.errorMessage = '';
  }

  private groupAvailableImagesByDate() {
    this.availableImagesByDate = {};
    let tmp = {};
    for (const [resolution, previews] of Object.entries(this.availableImages)) {
      previews.forEach(previewData => {
        let dateKey = previewData.date;
        if (!this.availableImagesByDate.hasOwnProperty(dateKey)) {
          this.availableImagesByDate[dateKey] = {};
        }
        if (!this.availableImagesByDate[dateKey].hasOwnProperty(resolution)) {
          this.availableImagesByDate[dateKey][resolution] = [];
        }
        this.availableImagesByDate[dateKey][resolution].push(previewData);
      });
    }

    let keys = Object.keys(this.availableImagesByDate);
    keys.sort().reverse();
    keys.forEach(timestamp => {
      tmp[timestamp] = this.availableImagesByDate[timestamp];
    });
    this.availableImagesByDate = tmp;
    //
    // this.availableImagesByDate = tmp;
  }

  getDateString(timestamp) {
    let d = new Date();
    d.setTime(parseInt(timestamp) * 1000);
    let dateKey = d.toLocaleDateString();
    return dateKey;
  }

  previewOverlay() {
    this.previewError = null;
    // this.isLoading = true;
    this.overlayService.previewOverlay(this.selectedItem[1], this.coordinates)
      .then((availableImages) => {
        this.availableImages = availableImages;
        this.groupAvailableImagesByDate();
        // this.isLoading = false;
      }).catch((error)=>{
        console.error('catch previewOverlay error ', error);
        this.errorMessage = this.selectedOverlay.errorMessage || 'Technical problems. Can\'t load previews';
    });
  }

  selectImage(imageConfig) {
    this.selectedOverlayImage = imageConfig.id;
  }

  getSelectedOverlayPrice() {
    return this.getOverlayPrice(this.selectedOverlay, this.area);
  }

  getOverlayPrice(overlay, area = 1) {
    if (typeof(overlay.price) === 'function') {
      return overlay.price(area);
    }
    return Math.max(overlay.price, overlay.price * area);
  }

  overlayPreviewUrl(imageConfig) {
    let code = [
      this.selectedOverlay.initialConfig['image'],
      imageConfig.id,
      this.coordinates[0],
      this.coordinates[1],
      this.coordinates[2],
      this.coordinates[3]
    ];
    return '/api/load-overlay-preview/' + window['EVENT_ID'] + '?c=' + btoa(code.join('::'));
  }

  drawAoi() {
    this.modalRef.hide();
    this.hintManagerService.isTimeoutHint = false;
    this.hintManagerService.textColor = '#fb5915';
    this.hintManagerService.hintText = "Click on each point around the area you want to choose, double click to finish";
    this.view.startDrawingPolygon((positions) => {
      this.hintManagerService.hintText = null;
      if (positions.length > 2) {
        let latMin = null, latMax = null, lngMin = null, lngMax = null;
        positions.forEach((position) => {
          if (position.lat < latMin || latMin === null) {
            latMin = position.lat;
          }
          if (position.lat > latMax || latMax === null) {
            latMax = position.lat;
          }
          if (position.lng < lngMin || lngMin === null) {
            lngMin = position.lng;
          }
          if (position.lng > lngMax || lngMax === null) {
            lngMax = position.lng;
          }
        });

        let center = new MapPosition({
          lng: (lngMax + lngMin) / 2,
          lat: (latMax + latMin) / 2
        });
        this.coordinates = null;
        this.location = null;
        this.availableImages = null;
        this.selectedOverlayImage = null;

        this.geoLibService.geocode(center).then((address) => {
          if (
            !this.selectedOverlay.hasOwnProperty('checkAvailabilityInLocation')
            || this.selectedOverlay.checkAvailabilityInLocation(address, center)
          ) {
            this.coordinates = [latMin, lngMin, latMax, lngMax];
            this.location = address['address'];
            this.area = Math.ceil((this.geoLibService.computeArea([
              new MapPosition({lat: latMin, lng: lngMin}),
              new MapPosition({lat: latMax, lng: lngMin}),
              new MapPosition({lat: latMax, lng: lngMax}),
              new MapPosition({lat: latMin, lng: lngMax}),
            ]) / 1000000) * 10) / 10;
            this.locationError = null;
            this.previewOverlay();
          } else {
            this.locationError = 'This product is not available in the selected location.';
          }
        });
      }
      this.show(false);
      this.hintManagerService.clearHint();
    });
  }

  arePreviewsLoaded() {
    return !!this.availableImages;
  }

  selectedAOIHasPreviews() {
    return (this.arePreviewsLoaded() && Object.keys(this.availableImages).length > 0);
  }

}
